import {
  Component,
  ElementRef,
  Renderer2,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { ReplaySubject, takeUntil } from 'rxjs';

import { EmoteService, UserEmote } from '../../services/emote/emote.service';

@Component({
  selector: 'app-emote-stream',
  templateUrl: './emote-stream.component.html',
  styleUrl: './emote-stream.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmoteStreamComponent implements OnDestroy {
  private renderer2 = inject(Renderer2);
  private el = inject(ElementRef);
  private emoteService = inject(EmoteService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  private destroyed$ = new ReplaySubject<boolean>(1);
  public constructor() {
    this.emoteService.emoteStream$.pipe(takeUntil(this.destroyed$)).subscribe((emote) => {
      this.emitEmoji(emote);
      this.changeDetectorRef.markForCheck();
    });
  }
  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public emitEmoji(emoji: UserEmote): void {
    const container = this.el.nativeElement.querySelector('.emoji-container');
    if (!container) {
      return;
    }
    const emojiElement = this.renderer2.createElement('div');
    this.renderer2.addClass(emojiElement, 'emoji');
    this.renderer2.setProperty(emojiElement, 'textContent', emoji.emote?.native);

    const randomX = Math.random() * 100 - 50;
    this.renderer2.setStyle(emojiElement, 'left', `${randomX}px`);

    const randomDuration = Math.random() * 2 + 2;
    this.renderer2.setStyle(emojiElement, 'animation-duration', `${randomDuration}s`);

    this.renderer2.appendChild(container, emojiElement);

    emojiElement.addEventListener('animationend', () => {
      this.renderer2.removeChild(container, emojiElement);
    });
  }
}
